import { getRefineChips } from '@rocco/ui/filter-sort/components/filters-modal/refine/get-refine-chips';
import { getClearedFilterStates } from '@rocco/ui/filter-sort/utils/get-cleared-filter-states';
import type { useSearchFilters } from '@rocco/ui/filter-sort/hooks/use-search-filters';
import { AppliedFilterPills } from '@rocco/ui/filter-sort/components/AppliedFilterPills';

interface AppliedFiltersRowProps {
    searchFilters: ReturnType<typeof useSearchFilters>;
    theme?: 'light' | 'dark';
    className?: string;
}

/**
 * {@link AppliedFilterPills} wired to the rocco filter system: derives one
 * pill per applied filter value from the search-filter state (same derivation
 * as the Refine sheet's chips row), removes a value through the immutable
 * removed-state the chip carries, and clears via
 * {@link getClearedFilterStates} — matching the filter modal's Clear all,
 * which unchecks selections while keeping the category, search, sort and
 * facet scaffolding intact. Renders nothing when no filters are applied.
 */
export const AppliedFiltersRow = ({
    searchFilters,
    theme,
    className,
}: AppliedFiltersRowProps) => {
    const chips = getRefineChips(
        searchFilters.filterStates,
        searchFilters.config,
    );

    return (
        <AppliedFilterPills
            items={chips.map((chip) => ({
                id: chip.id,
                label: chip.label,
                onRemove: () =>
                    searchFilters.updateFilter(
                        searchFilters.getUpdatedFilterStates(
                            searchFilters.filterStates,
                            chip.filterKey,
                            chip.removedState,
                            chip.isFacet,
                        ),
                        true,
                    ),
            }))}
            onClearAll={() =>
                searchFilters.updateFilter(
                    getClearedFilterStates(searchFilters.filterStates),
                    true,
                )
            }
            theme={theme}
            className={className}
        />
    );
};
